import styled from "styled-components";

import { breakpoints } from "@/styles/breakpoints";

export const StyledReportDamage = styled.div<{ $isDisabled: boolean }>`
    ${(props) =>
        props.$isDisabled &&
        `
    position: relative;
    pointer-events: none;
    opacity: 0.5;

    &::before {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: auto;
    content: "";
    }
  `}
`;

export const StyledReportDamageHeader = styled.div`
    padding: 8px 16px;
    font-size: var(--size-16);
    font-weight: bold;
    color: var(--color-primary);
    text-transform: uppercase;
    background-color: var(--color-secondary-light);
    border-radius: var(--radius-top-10);

    @media ${breakpoints.mdMax} {
        padding: 10px 16px;
        font-size: var(--size-14);
    }
`;

export const StyledReportDamageContainer = styled.div`
    background-color: var(--color-white);
    border-radius: var(--radius-bottom-10);
    padding: 1.6rem;
    display: flex;
    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.15);
`;

export const StyledReportDamageDescription = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    p {
        margin: 0;
        font-size: var(--size-16);
        color: var(--color-grey-900);

        @media ${breakpoints.mdMax} {
            font-size: var(--size-14);
        }
    }
`;

export const StyledReportDamageImgContainer = styled.div`
    margin-left: 30px;
    margin-top: -10px;
    align-self: flex-end;
`;
